import React from 'react';
import ReactDOM from 'react-dom';
import 'styles/fonts/poppins/poppins.css';
import './reset.css';
import './index.less';
import App from './App';
import './i18n/index.js';
import * as serviceWorker from './serviceWorker';
// import startServer from 'mirage';

// Use mirage if dev env
if (process.env.NODE_ENV === 'development') {
  // startServer();
}
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
